import { Options } from "@contentful/rich-text-react-renderer";
import { BLOCKS, INLINES, MARKS, Text } from "@contentful/rich-text-types";
import React from "react";
import { EmbeddedAsset } from "../../../graphql-types";
import ExternalLink from "../ExternalLink";
import InternalLink from "../InternalLink";
import { EmbeddedImage } from "./EmbeddedImage";
import { EmbeddedVideo } from "./EmbeddedVideo";
import * as styles from "./rich-text-renderer.module.css";

const isAbsolute = (url: string) => /^https?:\/\//i.test(url);

export function createRendererOptions(assets: EmbeddedAsset[]): Options {
  return {
    renderNode: {
      [INLINES.HYPERLINK]: (node) => {
        const content = node.content[0] as Text;
        const match = (node.data.uri as string).match(
          /^https?:\/\/www.youtube(-nocookie)?.com\/embed\/(.*)/
        );

        if (match) {
          const embedID = match[2];
          return (
            <span className={styles.videoWrapper}>
              <iframe
                width="100%"
                height="100%"
                src={`https://www.youtube.com/embed/${embedID}`}
                title={content.data.value}
                frameBorder="0"
                allowFullScreen
              />
            </span>
          );
        }

        if (isAbsolute(node.data.uri)) {
          return (
            <ExternalLink href={node.data.uri}>{content.value}</ExternalLink>
          );
        }

        return (
          <InternalLink href={node.data.uri}>{content.value}</InternalLink>
        );
      },
      [BLOCKS.EMBEDDED_ASSET]: (node) => {
        const { url, contentType } = node.data.target.fields.file;
        const match = assets.find((_) => _.file.url === url);
        if (!match) {
          throw new Error(`You must pass the asset with URL: ${url}.`);
        }

        if (contentType.match(/^image\//)) {
          return <EmbeddedImage asset={match} />;
        }
        if (contentType.match(/^video\//)) {
          return <EmbeddedVideo asset={match} />;
        }

        throw new Error(
          `Unsupported embedded asset type passed to renderer: ${contentType}.`
        );
      },
    },
    renderMark: {
      [MARKS.BOLD]: (node) => <b className="font-bold">{node}</b>,
    },
  };
}
